import { render, staticRenderFns } from "./tProducts.vue?vue&type=template&id=26ac9e02&scoped=true"
import script from "./tProducts.vue?vue&type=script&lang=js"
export * from "./tProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac9e02",
  null
  
)

export default component.exports